<template>
  <header class="bg-green text-white py-3">
    <div class="container">
      
      <nav class="navbar navbar-expand-lg">
        <div class="container">
          <!-- Brand -->
          <a class="navbar-brand" href="#"><img src="@/assets/1b48a842410eee0cf150a5df4272e89f.png" width="20%"></a>

          <!-- Toggler for Mobile View -->
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <!-- Navbar Links -->
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ms-auto">
              <!-- Normal Menu Item -->
              <li class="nav-item">
                <router-link class="nav-link" to="/home">HOME</router-link>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  PROFIL
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <router-link class="dropdown-item" to="/pimpinan"
                      >PENGURUS</router-link
                    >
                  </li>
                  <li>
                    <router-link class="dropdown-item" to="/komisi"
                      >KOMISI</router-link
                    >
                  </li>
                 </ul>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/berita">BERITA</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/fatwa">FATWA</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/dai">DA'I MUI</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/home">KONSULTASI</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/khutbah">KHUTBAH</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/khutbah">KECAMATAN</router-link>
              </li>

              <!-- Dropdown Menu -->
              

              <!-- Contact Menu Item -->
              <!-- <li class="nav-item">
                <a class="nav-link" href="#contact">CONTACT</a>
              </li> -->
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "NavBar",
};
</script>

<style scoped>
.navbar {
  background-color: #3f9153; /* Ganti dengan warna yang diinginkan */
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
  color:white;
}
.nav-link{
min-width: 100px;
  color:white;
}
.nav-link :hover{
  color:green;
}
</style>
